// services/dashboard/formatDataConsolidateTable.js

/**
 * Consolida las filas sumando los valores de los datasets que comparten la misma etiqueta.
 * @param {Array} rows - Arreglo de objetos con label, data, backgroundColor y borderColor.
 * @returns {Array} Arreglo de filas consolidadas.
 */
export const consolidateRows = (rows) => {
    if (!rows || rows.length === 0) {
        return rows;
    }

    // Crear un mapa para agrupar por indicador (label)
    // En JS no necesitamos definir la estructura del mapa previamente
    const consolidatedMap = {};

    // Procesar cada fila
    rows.forEach(row => {
        const key = row.label;
        
        if (!consolidatedMap[key]) {
            // Primera vez que vemos este indicador, creamos una copia profunda de los datos
            consolidatedMap[key] = {
                label: row.label,
                data: [...row.data],
                backgroundColor: row.backgroundColor,
                borderColor: row.borderColor
            };
        } else {
            // Ya existe, sumar los valores numéricos
            row.data.forEach((value, index) => {
                if (consolidatedMap[key].data[index] !== undefined) {
                    consolidatedMap[key].data[index] += value;
                } else {
                    consolidatedMap[key].data[index] = value;
                }
            });
        }
    });

    // Calcular el total y redondear a 2 decimales
    const consolidatedRows = Object.values(consolidatedMap).map(row => {
        // Suma de todos los valores en el arreglo data
        const total = row.data.reduce((sum, val) => sum + val, 0);
        
        return {
            ...row,
            data: [Number(total.toFixed(2))] // Retornamos la suma formateada
        };
    });

    return consolidatedRows;
};